import React, { Fragment, useCallback, useEffect, useState } from 'react';
import {
    Search
    /* Box,
    DollarSign,
    UserPlus,
    Users,
    Chrome,
    Settings,
    Airplay,
    Slack,
    FolderPlus,
    File,
    Command,
    Cloud,
    Book,
    FileText,
    Server,
    Image,
    Sliders,
    Map,
    GitPullRequest,
    Calendar,
    Edit,
    Mail,
    MessageSquare,
    UserCheck,
    Layers,
    HelpCircle,
    Database,
    Headphones,
    Mic,
    ShoppingBag,
    AlertOctagon,
    Lock,
    Briefcase,
    BarChart */
} from 'react-feather';
import { Link } from 'react-router-dom';

import { MENUITEMS } from '../../../constant/menu';
import useFormatMessage from '../../../utils/useFormatMessage';

const SearchHeader = () => {

    const { t } = useFormatMessage();

    const [searchValue, setsearchValue] = useState('');
    const [searchOpen, setsearchOpen] = useState(false);

    const escFunction = useCallback((event) => {
        if (event.keyCode === 27) {
            //Do whatever when esc is pressed
            setsearchOpen(false)
            setsearchValue('')
        }
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);
        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    });

    const handleSearchKeyword = (keyword) => {
        keyword ? addFix() : removeFix();
        const items = [];
        setsearchValue(keyword);
        //eslint-disable-next-line
        MENUITEMS.filter(menuItems => {
            // Get the title in the correct language based on the selected language
            let title = t(menuItems.title);

            // Check if the keyword is included in the translated title
            if (title.toLowerCase().includes(keyword.toLowerCase()) && menuItems.type === 'link') {
                items.push(menuItems);
            }
            if (!menuItems.children) return false;

            //eslint-disable-next-line
            menuItems.children.filter(subItems => {
                let subTitle = t(subItems.title);
                if (subTitle.toLowerCase().includes(keyword.toLowerCase()) && subItems.type === 'link') {
                    subItems.icon = menuItems.icon;
                    items.push(subItems);
                }
                if (!subItems.children) return false;

                //eslint-disable-next-line
                subItems.children.filter(suSubItems => {
                    let suSubTitle = t(suSubItems.title);
                    if (suSubTitle.toLowerCase().includes(keyword.toLowerCase())) {
                        suSubItems.icon = menuItems.icon;
                        items.push(suSubItems);
                    }
                });
            });

            checkSearchResultEmpty(items);
            setsearchValue(items);
        });
    }

    const checkSearchResultEmpty = (items) => {
        if (!items.length) {
            document.querySelector(".empty-menu").classList.add('is-open');
        } else {
            document.querySelector(".empty-menu").classList.remove('is-open');
        }
    }

    const addFix = () => {
        document.querySelector(".Typeahead-menu").classList.add('is-open');
        document.body.classList.add("offcanvas");
    }

    const removeFix = () => {
        setsearchValue('')
        document.querySelector(".Typeahead-menu").classList.remove('is-open');
        document.body.classList.remove("offcanvas");
    }

    const toggleBtn = () => {
        if (searchOpen) {
            setsearchOpen(!searchOpen);
            document.querySelector('.searchIcon').classList.add('open');
        } else {
            setsearchOpen(!searchOpen);
            document.querySelector('.searchIcon').classList.remove('open');
        }
    }


    return (
        <Fragment>
            <div>
                <form className="form-inline search-form">
                    <div className="form-group">
                        <input
                            className="form-control-plaintext searchIcon"
                            type="text"
                            placeholder={t("Ara")}
                            defaultValue={searchValue}
                            onChange={(e) => handleSearchKeyword(e.target.value)}
                        />
                        <span className="d-sm-none mobile-search" onClick={toggleBtn}>
                            <Search />
                        </span>

                        <div className="Typeahead-menu custom-scrollbar" id="search-outer">
                            {searchValue ?
                                searchValue.map((data, index) => {
                                    return (
                                        <div className="ProfileCard u-cf" key={index}>
                                            <div className="ProfileCard-avatar">
                                                <data.icon />
                                            </div>
                                            <div className="ProfileCard-details">
                                                <div className="ProfileCard-realName">
                                                    <Link
                                                        to={`${process.env.PUBLIC_URL}${data.path}`}
                                                        className="realname"
                                                        onClick={removeFix}
                                                    >
                                                        {t(data.title)}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }) : ''
                            }
                        </div>
                        <div className="Typeahead-menu empty-menu">
                            <div className="tt-dataset tt-dataset-0">
                                <div className="EmptyMessage">
                                    Sonuç bulunamadı..
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </Fragment>
    );
};

export default SearchHeader;
